import { SupabaseServiceView } from "../../../server/supabase/base-supabase-service";

import type { Database } from "../../../__definitions__/database-definitions";

export type SurveyStatus = Database["public"]["Views"]["survey_status"]["Row"];
export type MomentFormSurvey = Database["public"]["Views"]["moment_form_survey"]["Row"];

export class SupabaseMomentFormSurveyService extends SupabaseServiceView<"moment_form_survey"> {
  table = "moment_form_survey" as const;
}
